<div>Původně: {{ data.doneBefore }} z {{ data.totalBefore }} {{ data.unit }}</div>
<div>Nyní: {{ data.done }} z {{ data.total }} {{ data.unit }}</div>
